import { render, staticRenderFns } from "./addCoursework.vue?vue&type=template&id=5aea377c&"
import script from "./addCoursework.vue?vue&type=script&lang=js&"
export * from "./addCoursework.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports